export default {"src":"/_next/static/media/CBRE.b141e0d3.svg","height":18,"width":18};